var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmbeddedCodeIcon = function SvgEmbeddedCodeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 9,
    fill: "none",
    viewBox: "0 0 20 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.564 4.067 5.212 2.655v1.406L.712 4.797v-.853zm5.212-2.24L1.573 4.497l-.861.088v-.853L6.776.411zM18.633 4.4l-5.335-2.628V.393l6.284 3.323v.861zm-5.335 2.33 5.344-2.672.94-.132v.861L13.298 8.12z"
  })));
};
export default SvgEmbeddedCodeIcon;